import i18n from '@/plugins/i18n'

export const IMMEDIATE_VIDEO  = 1
export const INPLACE = 2
export const VIDEO = 4
export const WRITTEN = 5
export const PERSONAL = 6
export const SECOND_OPINION = 7
export const COMPANIES = 8
export const AT_HOME = 9
export const CHAT = 10
export const CALL = 11
export const INSURANCE = 12
export const FLAT_RATE = 'flatRate'
export const SERVICES_PACKAGES = 'servicesPackages'
export const BUDGET = 'budget'
export const INTERCONSULTATION = 13

const iconsBasePath = '/static-appopensalud/img/icons/services/'
export const CONSULTATIONS_TYPES_ICONS = {
    [INPLACE]: `${iconsBasePath}inplace.svg`,
    [VIDEO]: `${iconsBasePath}video.svg`,
    [IMMEDIATE_VIDEO]: `${iconsBasePath}immediate.svg`,
    [WRITTEN]: `${iconsBasePath}written.svg`,
    [SECOND_OPINION]: `${iconsBasePath}second-opinion.svg`,
    [AT_HOME]: `${iconsBasePath}at-home.svg`,
    [CHAT]: `${iconsBasePath}chat.svg`,
    [CALL]: `${iconsBasePath}call.svg`,
    [INSURANCE]: `${iconsBasePath}insurance.svg`
}
export const CONSULTATIONS_TYPES_COLOURS = {
    [INPLACE]: '#3498DB',
    [VIDEO]: '#1ABC9C',
    [IMMEDIATE_VIDEO]: '#267F6E',
    [WRITTEN]: '#F39C12',
    [SECOND_OPINION]: '#9B59B6',
    [AT_HOME]: '#1D6089',
    [CHAT]: '#CD840F',
    [CALL]: '#A0A9E8',
    [INSURANCE]: '#5271FF'
}
export const APPOINTMENT_REQUEST_TYPES = {
    instant: IMMEDIATE_VIDEO,
    inplace: INPLACE,
    online: VIDEO,
    webmail: WRITTEN,
    personal: PERSONAL,
    secondOpinion: SECOND_OPINION,
    away: AT_HOME,
    webmailExpress: CHAT,
    call: CALL,
    insurance: INSURANCE,
    flatRate: FLAT_RATE,
    servicesPackages: SERVICES_PACKAGES,
    budget: BUDGET
}
export const CONSULTATIONS_REQUIRE_PAYMENT = [IMMEDIATE_VIDEO, INPLACE, VIDEO, WRITTEN, SECOND_OPINION, CHAT, CALL, FLAT_RATE, SERVICES_PACKAGES]
export const FLAT_RATE_ICON = '/static-appopensalud/img/icons/services/flat-rate.svg'
export const SERVICES_PACKAGES_ICON = '/static-appopensalud/img/icons/services/services-packages.svg'
export const TESTS_ICON = '/static-appopensalud/img/icons/services/tests.svg'
export const BUDGET_ICON = '/static-appopensalud/img/icons/morillas-svg-icons/neu/ICN_OUT_PRECIO.svg'
export const ANALYSIS_ICON = '/static-appopensalud/img/icons/services/analysis.svg'
export const OTHER_CONSULTATIONS_ICON = '/static-appopensalud/img/icons/services/other-consultations.svg'
export const FLAT_RATE_COLOUR = '#E8A0A4'
export const SERVICES_PACKAGES_COLOUR = '#D2414C'
export const TESTS_COLOUR = '#43B8C4'
export const ANALYSIS_COLOUR = '#43B8C4'
export const DEFAULT_COLOUR = '#3238C4'

export function getConsultationIconById (consultationId) {
    return CONSULTATIONS_TYPES_ICONS[consultationId]
}
export function getConsultationColourById (consultationId) {
    return CONSULTATIONS_TYPES_COLOURS[consultationId]
}
export function getConsultationTitleById (consultationId) {
    // included inside function because i18n not loaded in PrivateLayout
    const CONSULTATIONS_TYPES_TITLES = {
        [INPLACE]: i18n.t('services-title.type-one'),
        [VIDEO]: i18n.t('services-title.type-two'),
        [IMMEDIATE_VIDEO]: i18n.t('services-title.type-five'),
        [WRITTEN]: i18n.t('services-title.type-four'),
        [SECOND_OPINION]: i18n.t('services-title.type-seven'),
        [AT_HOME]: i18n.t('services-title.type-six'),
        [CHAT]: i18n.t('services-title.type-three'),
        [CALL]: i18n.t('services-title.type-ten'),
        [INSURANCE]: i18n.t('services-title.type-eleven')
    }
    return consultationId ? CONSULTATIONS_TYPES_TITLES[consultationId] : CONSULTATIONS_TYPES_TITLES
}


// WEBPACK FOOTER //
// ./src/constants/consultationTypes.js